<!-- 缺货-进行装运&拒绝履约弹框 -->
<template>
  <el-dialog
    width="450px"
    :show-close="false"
    :visible.sync="visible"
    destroy-on-close
    :close-on-click-modal="false"
  >
    <!-- 装运弹框 -->
    <div v-if="isProceedShipment" class="proceed-shipment">
      <div class="back_icon" @click="visible = false">
          <i class="el-icon-arrow-left"></i>
          <span>Proceed the shipment</span>
      </div>
      <div>
        The retailer confirms that the remaining products can be shipped, please check that the remaining products are not out of stock, and can be shipped all at once
      </div>
      <div class="footer">
        <el-button type="primary" class="btn" @click="submit">Submit</el-button>
        <el-button class="info" @click="visible = false">Cancel</el-button>
      </div>
    </div>

    <!-- 拒绝履约 -->
    <div v-else class="refuse-fulfill">
      <p>Reject order</p>
      <div>Reason for rejection <span style="color: #FB541C">*</span></div>
      <el-input
        type="textarea"
        :rows="4"
        maxlength="200"
        show-word-limit
        placeholder="Fill in the reason for refusal"
        v-model="rejectionReason">
      </el-input>
      <div class="required-error" v-if="!rejectionReason">Please enter rejection reason</div>
      <div class="tips">This information was shown to retailer</div>
      <div class="sync-sku">
        <el-checkbox v-model="isSyncSku">Synchronize setting the SKU items in the order as inactive.</el-checkbox>
      </div>
      <div class="footer">
        <el-button type="primary" class="btn" @click="submit">Submit</el-button>
        <el-button class="info" @click="visible = false">Cancel</el-button>
      </div>
    </div>

  </el-dialog>
</template>

<script>
import qs from 'qs'
import {putAction} from '../../api/manage'
import Vue from 'vue'
export default {
  name: 'out-stock',
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      step: 1,
      rejectionReason: '',
      isProceedShipment: false,
      orderId: '',
      isSyncSku: true
    }
  },
  created() {
  },
  methods: {
    show(isProceedShipment, orderId) {
      this.isProceedShipment = isProceedShipment
      this.visible = true
      this.orderId = orderId
      this.rejectionReason = ''
    },
    submit() {
      // 拒绝履约时，拒绝原因不能为空
      if (!this.isProceedShipment && !this.rejectionReason) {
        return
      }

      let url = this.isProceedShipment ? `order/api/v0.2/brand/orders/${this.orderId}/proceed-shipmented` : `order/api/v0.2/brand/orders/${this.orderId}/refuse-fulfill?refuseFulfillReason=${this.rejectionReason}&isSyncSku=${this.isSyncSku}`
      putAction(url).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          location.reload()
        } else {
          this.$message.error(res.message)
        }
      })
    }

  },
  filters: {
    numberValueFormat: (value) => {
      return !value ? 0 : value
    }
  }
}

</script>

<style lang="less" scoped>
.footer{
  display: flex;
  justify-content: center;
}
.btn{
  background-color: #262b2f;
  border-color: #262b2f;
  margin-right: 20px;
}

.info .el-button--default:focus,
.el-button--default:active,
.el-button--default:hover {
  background-color: #ffffff !important;
  color: #262b2f !important;
  border-color: #262B2F;
}

.proceed-shipment{
  padding: 20px;
  .back_icon {
    font-size: 14px;
    font-family: Avenir;
    font-weight: 500;
    line-height: 40px;
    color: #262b2f;
    margin: 0 0 0 10px;
    cursor: pointer;
  }
  div:nth-child(2){
    color: #5D5D5D;
    font-size: 14px;
    margin: 15px 0;
    padding: 0 15px;
  }

}

.refuse-fulfill {
  padding: 20px;
  div:nth-child(2){
    margin-top: 30px;
  }
  p {
    color: #262B2F;
    font-size: 14px;
    font-weight: bold;
    font-family: Satoshi;
  }

  .tips {
    margin-top: 10px;
    font-size: 14px;
    font-family: Graphik;
    color: #8F8F8F;
  }
  .sync-sku{
    margin: 20px 0px 40px 0px;
  }
}
.required-error {
  font-size: 12px;
  color: #F77073;
  font-weight: 400;
  height: 20px;
  line-height: 20px;
}

</style>



// WEBPACK FOOTER //
// src/pages/order/out-stock-confirm-dialog.vue